export default __webpack_public_path__ + "static/media/shipetiari1.5beedfb0.jpg";